import type { ReactNode } from 'react';
import { Button, TableBody, TableHead, TableRow } from '@ksyos/design-system';
import { ProfessionalSummaryDataTable } from '@frontend/components/pages/professionalSummaryData/ProfessionalSummaryDataTable';
import { getSelectedLanguage } from '@frontend/translate';
import { MedicationsAddEditTableHeader } from './MedicationsAddEditTableHeader';

interface IMedicationsAddEditTableProps {
    addEmptyMedicationRecord?: () => void;
    tableRows: ReactNode[];
}

export function MedicationsAddEditTable(props: IMedicationsAddEditTableProps) {
    const { addEmptyMedicationRecord, tableRows } = props;

    const translate = getSelectedLanguage();

    return (
        <>
            <ProfessionalSummaryDataTable>
                <TableHead>
                    <TableRow>
                        <MedicationsAddEditTableHeader />
                    </TableRow>
                </TableHead>
                <TableBody>{tableRows}</TableBody>
            </ProfessionalSummaryDataTable>
            {addEmptyMedicationRecord && (
                <Button
                    iconLeft="add"
                    onClick={() => addEmptyMedicationRecord!()}
                    sx={{ mb: 4, ml: 2 }}
                    variant="link"
                >
                    {translate.medications.addMedication}
                </Button>
            )}
        </>
    );
}
